import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getMultiLangProperty } from "../../../../helpers/generalHelper";

const MenuCart = ({ cartData, currency, deleteFromCart, allowLinksell }) => {
  const { t, i18n } = useTranslation();
  let cartTotalPrice = 0;
  return (
    <div className="shopping-cart-content">
      {Array.isArray(cartData.items) && cartData.items.length > 0 ? (
        <>
          <ul>
            {cartData.items.map((single, key) => {
              const finalProductPrice =
                single.product.price * currency.currencyRate * single.qty;
              cartTotalPrice += finalProductPrice;

              return (
                <li className="single-shopping-cart" key={key}>
                  <div className="shopping-cart-img">
                    <Link
                      to={`${process.env.PUBLIC_URL}/product/${single.product._id}`}
                    >
                      <img
                        alt=""
                        src={single?.product?.media?.[0]?.fileUrl}
                        className="img-fluid"
                      />
                    </Link>
                  </div>
                  <div className="shopping-cart-title">
                    <h4>
                      <Link
                        to={`${process.env.PUBLIC_URL}/product/${single.product._id}`}
                      >
                        {getMultiLangProperty(
                          single.product.name,
                          i18n.language
                        )}
                      </Link>
                    </h4>
                    <h6>{`${t("navMenu.quantity")}: ${single.qty}`}</h6>
                    <span>
                      {currency.currencySymbol +
                        finalProductPrice.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                        })}
                    </span>
                    {Array.isArray(single.product.attributes) &&
                      single.product.attributes.map(
                        ({ attributeLabel, optionLabel }, index) => (
                          <div className="cart-item-variation" key={index}>
                            <span>
                              {`${getMultiLangProperty(
                                attributeLabel,
                                i18n.language
                              )}: ${getMultiLangProperty(
                                optionLabel,
                                i18n.language
                              )}`}
                            </span>
                          </div>
                        )
                      )}
                    {single.orderAttribute &&
                      Object.keys(single.orderAttribute).map((key, index) => (
                        <div className="cart-item-variation" key={index}>
                          <span>
                            {`${t(`productDetails.${key}`)}: ${
                              single.orderAttribute[key]
                            }`}
                          </span>
                        </div>
                      ))}
                  </div>
                  <div className="shopping-cart-delete">
                    <button
                      onClick={() =>
                        deleteFromCart(
                          single.product._id,
                          key,
                          single.product.isRedeemable
                        )}
                    >
                      <i className="fa fa-times-circle" />
                    </button>
                  </div>
                </li>
              );
            })}
          </ul>
          <div className="shopping-cart-total">
            <h4>
              {`${t("navMenu.total")}: `}
              <span className="shop-total">
                {currency.currencySymbol +
                  cartTotalPrice.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                  })}
              </span>
            </h4>
          </div>
          <div className="shopping-cart-btn btn-hover text-center">
            <Link className="default-btn" to={`${process.env.PUBLIC_URL}/cart`}>
              {t("navMenu.viewCart")}
            </Link>
            {!allowLinksell && (
              <Link
                className="default-btn"
                to={{
                  pathname: `${process.env.PUBLIC_URL}/checkout`,
                  state: { cartID: cartData._id },
                }}
              >
                {t("navMenu.checkout")}
              </Link>
            )}
          </div>
        </>
      ) : (
        <p className="text-center">{t("navMenu.noItemInCart")}</p>
      )}
    </div>
  );
};

MenuCart.propTypes = {
  cartData: PropTypes.object,
  currency: PropTypes.object,
  deleteFromCart: PropTypes.func,
};

export default MenuCart;
